export const tokencontractConstants = {
  TOKENCONTRACT_SELECTED: "TOKENCONTRACT_SELECTED",
};
